import React from 'react';

/* Pages statiques du footer — FormAcademy (correctif C3, 16/09/2026) */

const PageShell: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="min-h-screen bg-white">
    <section className="bg-gradient-to-br from-gray-900 to-black text-white py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl sm:text-4xl font-bold">{title}</h1>
      </div>
    </section>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-gray-700 leading-relaxed space-y-6">
      {children}
    </div>
  </div>
);

const H2: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h2 className="text-xl font-semibold text-gray-900 pt-4">{children}</h2>
);

export const ContactPage: React.FC = () => (
  <PageShell title="Contact">
    <p>
      Une question sur nos formations, l'inscription ou l'accès à votre espace
      apprenant ? Notre équipe vous répond du lundi au vendredi, de 9h à 18h (GMT).
    </p>
    <div className="bg-gray-50 rounded-xl p-6 space-y-3 border border-gray-200">
      <p><strong>Email :</strong> contact@formacademy-sn.com</p>
      <p><strong>Téléphone / WhatsApp :</strong> +33 6 58 84 50 35</p>
      <p><strong>FormAcademy — Kayliss Digital</strong><br />
      Dakar, Sénégal</p>
    </div>
    <H2>Support technique</H2>
    <p>
      Pour tout problème d'accès à une formation (vidéo, PDF, quiz), précisez
      votre adresse e-mail d'inscription et le titre de la formation concernée :
      le support vous répond sous 24 h ouvrées.
    </p>
    <H2>Formateurs & partenariats</H2>
    <p>
      Vous êtes formateur ou organisation et souhaitez proposer un programme ?
      Écrivez-nous à <strong>partenariats@formacademy-sn.com</strong>.
    </p>
  </PageShell>
);

export const MentionsLegalesPage: React.FC = () => (
  <PageShell title="Mentions légales">
    <H2>Éditeur du site</H2>
    <p>
      Le site formacademy-sn.com est édité par <strong>FormAcademy</strong>,
      plateforme e-learning exploitée par Kayliss Digital (SIREN/RCS :
      913 900 809 00017), dont le siège est situé à Dakar, Sénégal.
      Président : Zakaria NIANG. Contact : contact@formacademy-sn.com —
      +33 6 58 84 50 35.
    </p>
    <H2>Hébergement</H2>
    <p>
      Le site est hébergé sur une infrastructure dédiée (serveur NAS/HTTPS,
      certificat SSL Let's Encrypt). Contact hébergeur via
      contact@formacademy-sn.com.
    </p>
    <H2>Propriété intellectuelle</H2>
    <p>
      L'ensemble des contenus du site (textes, visuels, logos, vidéos, supports
      de formation, code source) est protégé par le droit d'auteur. Toute
      reproduction, diffusion ou revente, totale ou partielle, sans
      autorisation écrite préalable est interdite. L'accès aux formations est
      strictement personnel et non cessible.
    </p>
    <H2>Données personnelles</H2>
    <p>
      Les données collectées (nom, e-mail, progression pédagogique) servent
      uniquement à la gestion de votre compte et de vos formations. Elles ne
      sont ni vendues ni cédées à des tiers. Conformément à la réglementation
      en vigueur, vous disposez d'un droit d'accès, de rectification et de
      suppression de vos données en écrivant à contact@formacademy-sn.com.
    </p>
    <H2>Responsabilité</H2>
    <p>
      FormAcademy s'efforce d'assurer l'exactitude des informations publiées
      mais ne saurait être tenue responsable des erreurs, omissions ou d'une
      indisponibilité temporaire du service.
    </p>
  </PageShell>
);

export const CgvPage: React.FC = () => (
  <PageShell title="Conditions générales de vente">
    <H2>1. Objet</H2>
    <p>
      Les présentes CGV régissent la vente de formations en ligne (accès à des
      contenus vidéo, PDF et quiz) proposées sur formacademy-sn.com. Toute
      commande implique l'acceptation sans réserve des présentes CGV.
    </p>
    <H2>2. Prix</H2>
    <p>
      Les prix sont indiqués en euros (€) pour certaines formations et en
      francs CFA (FCFA) pour les formations « Inclusion numérique », toutes
      taxes comprises. Les prix affichés sur la fiche de la formation font foi
      au moment de la commande.
    </p>
    <H2>3. Commande et paiement</H2>
    <p>
      L'inscription se fait en ligne : création d'un compte, sélection de la
      formation et paiement selon les moyens proposés sur la page de
      commande. L'accès au contenu est activé après confirmation du
      paiement.
    </p>
    <H2>4. Accès aux formations</H2>
    <p>
      L'accès est personnel, non transférable et valable pour la durée
      indiquée sur la fiche de la formation (sauf mention contraire, 12 mois
      à compter de l'activation). Une connexion Internet est requise.
    </p>
    <H2>5. Droit de rétractation et remboursement</H2>
    <p>
      Conformément à la réglementation applicable aux contenus numériques,
      le droit de rétractation ne peut être exercé après le début effectif de
      l'exécution du service (premier accès au contenu de la formation),
      sauf accord commercial spécifique. Toute demande de remboursement doit
      être adressée à contact@formacademy-sn.com.
    </p>
    <H2>6. Litiges</H2>
    <p>
      Les présentes CGV sont soumises au droit applicable au siège de
      l'éditeur. En cas de litige, une solution amiable sera recherchée en
      priorité ; à défaut, les tribunaux compétents du ressort du siège
      social seront saisins.
    </p>
  </PageShell>
);

export default { ContactPage, MentionsLegalesPage, CgvPage };
